import { TeamMemberRole } from '../../../types/GloblalTypes';
export var getUserTeamRoles = function (teamData) {
    var _a, _b, _c, _d;
    var teamAccountRoles = ((_d = (_c = (_b = (_a = teamData === null || teamData === void 0 ? void 0 : teamData.teamData) === null || _a === void 0 ? void 0 : _a.team) === null || _b === void 0 ? void 0 : _b.teamAccountRoles) === null || _c === void 0 ? void 0 : _c.roles) !== null && _d !== void 0 ? _d : []).filter(function (tar) { return !!tar; });
    var isMemberOfSomeTeam = teamAccountRoles.some(function (tar) { return tar.role === TeamMemberRole.MEMBER; });
    var isAdminOfSomeTeam = teamAccountRoles.some(function (tar) { return tar.role === TeamMemberRole.ADMIN; });
    return {
        isAdmin: isAdminOfSomeTeam,
        isMember: isMemberOfSomeTeam,
    };
};
